import { ActiveI9ListFilters } from '../domain/entities/ActiveI9ListFilters';
import { IActiveI9Repository } from '../ports/outbound/IActiveI9Repository';
import { ActiveI9Result } from '../domain/entities/ActiveI9Result';
import { LocationItem } from '../domain/entities/LocationItem';
import { SortOrder } from '@/shared/application/domain/enums/SortOrder';

export class FetchActiveI9ItemsUseCase {
  constructor(private repo: IActiveI9Repository) {}
  async fetchActiveI9Records(
    page: number,
    pageSize: number,
    location?: string,
    status?: string,
    hireDate?: string,
    employeeFirstName?: string,
    employeeLastName?: string,
    columnName?: string,
    sortOrder?: SortOrder,
    filters?: ActiveI9ListFilters
  ): Promise<ActiveI9Result> {
    return this.repo.fetchActiveI9Records(
      page,
      pageSize,
      location,
      status,
      hireDate,
      employeeFirstName,
      employeeLastName,
      columnName,
      sortOrder,
      filters
    );
  }

  async getLocations(): Promise<LocationItem[]> {
    return this.repo.getLocations();
  }
}
